import { observable } from 'mobx';
import BaseStore from '@src/utils/store/base-store';
import { autobind } from 'core-decorators';
import CultureSwiperStore from '@src/business-components/navibar/components/culture-swiper/store';
import { useLayerData } from '@src/utils/hooks/use-layer-data';
import { useEffect } from 'react';
import { useMount } from 'ahooks';

class NaviBarStore extends BaseStore {
  constructor({ ...rest } = {}) {
    super();
    Object.assign(this, rest);
  }
  cultureSwiperStore = new CultureSwiperStore();

  @observable isLoading = true;

  @observable isExpand = false;

  @observable layerData = {};
  @observable navList = [];
  @observable rightNavList = [];
  @observable expandedNavList = [];
  @observable cultureSwiperList = [];

  @autobind
  onLogoMenuHover() {
    this.isExpand = true;
  }

  @autobind
  closeExpandMenu() {
    this.isExpand = false;
  }

  use() {
    super.use();

    const data = useLayerData('header');

    useMount(() => {
      this.isActive = true;
    });

    useEffect(
      
      () => {
        this.isLoading = data == null;
        if (data) {
          this.layerData = data;
          this.navList = data.nav || [];
          this.rightNavList = data.right_nav || [];
          this.expandedNavList = data.expand_nav || [];
          this.cultureSwiperList = data.expand_swiper?.map(item => ({ title: item.main_title, img: item.image_src }));
        }
      },
      [data]
    );
  }
}

export default NaviBarStore;
